<template>
<div class="c-substep step-6-1">
  <div class="c-substep-popup">
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
    </p>
    <button v-on:click="close()">Zamknij komunikat</button>
    <button class="white" v-on:click="goToMainPage()">Przejdź do strony głównej</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

export default {
  name: 'step6-1',
  methods: {
    close() {
      this.$store.dispatch('closeSubStep');
    },
    goToMainPage() {
      window.location.replace('?end=1');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
